import React, { useState, useEffect, useRef, useCallback } from 'react';
import '../../../styles/JenineCharisse.css';
import bgMusic from '../../../assets/sounds/jenine-charisse-bg-music.mp3';
import logicaLogo from '../../../assets/images/Logica (Black and White).webp';
import programFlowBg from '../../../assets/images/jenine-charisse/program-flow-bg.webp';
import programFlowBgMobile from '../../../assets/images/jenine-charisse/program-flow-bg-mobile.webp';
import programFlowBgSmallMobile from '../../../assets/images/jenine-charisse/program-flow-bg-small-mobile.webp';
import countdownTimerCardBg from '../../../assets/images/jenine-charisse/countdown-timer-card-bg.webp';
import celebrationDetailsBg from '../../../assets/images/jenine-charisse/celebration-details-bg.webp';
import charissePicture from '../../../assets/images/jenine-charisse/charisse-picture2.webp';
import gallery1 from '../../../assets/images/jenine-charisse/charisse-gallery-1.webp';
import gallery3 from '../../../assets/images/jenine-charisse/charisse-gallery-3.webp';
import gallery4 from '../../../assets/images/jenine-charisse/charisse-gallery-4.webp';
import gallery5 from '../../../assets/images/jenine-charisse/charisse-gallery-5.webp';
import gallery6 from '../../../assets/images/jenine-charisse/charisse-gallery-6.webp';
import gallery7 from '../../../assets/images/jenine-charisse/charisse-gallery-7.webp';
import gallery8 from '../../../assets/images/jenine-charisse/charisse-picture1.webp';
import galleryImg240 from '../../../assets/images/jenine-charisse/charisse-gallery-img240.webp';
import galleryImg422 from '../../../assets/images/jenine-charisse/charisse-gallery-img422.webp';
import galleryImg108 from '../../../assets/images/jenine-charisse/charisse-gallery-img262.webp';
import giftFloral from '../../../assets/images/jenine-charisse/gift-floral.webp';
import dressCodeClipart from '../../../assets/images/jenine-charisse/dress-code-clipart.webp';
import palacioVenue from '../../../assets/images/jenine-charisse/palacio-event-place.webp';
import cursiveName from '../../../assets/images/jenine-charisse/cursive-janine-charisse.webp';
import cursiveNameFooter from '../../../assets/images/jenine-charisse/cursive-janine-charisse-footer.webp';
import motherFatherCursiveName from '../../../assets/images/jenine-charisse/mother-father-cursive-name.webp';

/* ── Constants ─────────────────────────────────────────────────────── */
const EVENT_DATE = new Date('2026-05-24T16:00:00+08:00');
const RSVP_DL = 'May 8, 2026';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

/* ── Traditions Data ────────────────────────────────────────────────── */
const rosesList = [
    'Jack Luciano', 'Euan Pasajol', 'Ivan Carandang', 'Ryan Banzuela',
    'Mark Lucido', 'Gian Castillo', 'Lance Puhawan', 'Yuwin Pravin',
    'Dalziel Nave', 'Lance Balitaan', 'Aerem Manalo', 'Freddy Solis',
    'John Solis', 'Vergillio Caston', 'Argie Luciano', 'Frederick Solis',
    'Jesus Claro Nave', 'Alfred Franz Solis',
];
const candlesList = [
    'Jennifer Claire Nave', 'Jillianne Christia Luciano', 'Jeselle Ceril Nave',
    'Jovilyn Nave', 'Armelinda Solis', 'Zenaida Aguila', 'Myrna Solis',
    'Jana Risha', 'Hana Yesha', 'Racquel Aguila', 'Jillian Garcia',
    'Liuchei Robillos', 'KC Consignado', 'Razel Nave', 'Paola Quitalig',
    'Sharmaine Bucayo', 'Marilyn Medina', 'Rehlee Diola',
];
const shotsList = [
    'Lance Puhawan', 'Anne Kathryna Liay', 'Veronica Jimenez',
    'Allison Maxim Avila', 'Tanikka Kody Cedro', 'Janella Iglesia',
    'Lhyma Alvaran', 'Ivan Carandang', 'Erasmo Tolentino', 'Ryan Banzuela',
    'Mark Lucido', 'Albeana Cometa', 'Yanyan Prashana', 'Trojean Legaspi',
    'Benjamin Usana', 'Zean Atienza', 'Neiah Magkawas', 'Emman Malabanan',
];
const billsList = [
    'Jillianne Christia Luciano', 'Jeselle Ceril Nave', 'Jon Aguila',
    'Helen Aguila', 'Maria Aguila', 'John Solis', 'Maan De Lima',
    'Rj Pasajol', 'Michael Guanzon', 'Jasper Nave', 'Kevin Nave',
    'Lizza Garcia', 'Beth Mercado', 'Julie Sumaoang', 'Nicolas Aguila',
    'Liza Hayashi', 'Abigail Laluz', 'Ron Arban',
];

/* ── Program Flow ───────────────────────────────────────────────────── */
const programFlow = [
    'Opening prayer',
    'Opening spill',
    'Introduction to the Family',
    'Intro video',
    'Opening production of the celebrant',
    'Growing up video',
    'Flash mob',
    'Games',
    'Opening remarks',
    'Re-Entrance',
    'Mini Cotillion',
    '18 Roses',
    "Father's speech",
    '18 Shots',
    'Intermission number',
    'Games',
    'Re-Entrance',
    '18 Bills',
    '18 Candles',
    "Mother's speech",
    'Blowing of cake / Birthday song',
    'Photo opportunity',
    'Dinner',
    'Games',
    'SDE',
    'Message of the celebrant',
    'Closing spill',
    'Grand Photo opportunity',
    'After party',
];

/* ── FAQ Data ───────────────────────────────────────────────────────── */
const faqs = [
    {
        q: 'When is the RSVP deadline?',
        a: `Kindly confirm your attendance on or before ${RSVP_DL}. Your early response helps us prepare a wonderful celebration for everyone. Please note that guests who have not submitted an RSVP will not be included in the reservations list — as we want to keep the event organized, no reservation means no entry.`,
    },
    {
        q: 'Is there parking available?',
        a: "There are ample parking spaces at Palacio's Event Place, so there is no need to worry if you want to bring a car.",
    },
    {
        q: 'Will there be a seating arrangement?',
        a: "Yes! A coordinator will assist you when you enter Palacio. They will give you your seat number — please be seated once you receive your table number.",
    },
    {
        q: 'What amenities are available?',
        a: 'A grazing table, mobile bar, and photobooth will be available throughout the evening for all guests to enjoy.',
    },
    {
        q: 'Can I take photos and videos?',
        a: 'Absolutely! We encourage everyone to take as many videos and photos as they like. Please do not forget to send them to the Facebook account "Claire Nave."',
    },
    {
        q: 'Can I leave a message for the celebrant?',
        a: "Yes! We would really appreciate it if you bring a letter to drop in the box available on the coordinators\u2019 table. The celebrant will be happy to read all your messages and wishes \u2014 it is something she can keep and treasure.",
    },
    {
        q: 'What if I am part of the 18 Candles, 18 Shots, or 18 Bills?',
        a: "Please prepare a short birthday message or wish for the celebrant. Write it in a letter and you can read it to her once your name is called. After that, you may place it in the same letter box at the coordinator's table.",
    },
];

/* ═══════════════════════════════════════════════════════════════════════
   SVG COMPONENTS
   ═══════════════════════════════════════════════════════════════════════ */

/**
 * Peony + leaf + vine corner piece.
 * Designed for the top-left corner (flower at ≈28,28).
 * CSS transforms on the wrapper create the other 3 corners.
 */
const BotanicalCornerSVG = () => (
    <svg viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#8B9E8A" strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round">
            {/* ── Peony outer petals ── */}
            <path d="M28 28 C22 12 12 4 6 6 C10 18 20 24 28 28Z" />
            <path d="M28 28 C20 8 22 0 28 0 C34 0 36 8 28 28Z" />
            <path d="M28 28 C36 10 46 4 50 8 C46 20 36 26 28 28Z" />
            <path d="M28 28 C46 24 54 30 52 38 C44 40 34 34 28 28Z" />
            <path d="M28 28 C42 36 44 48 38 52 C30 48 26 38 28 28Z" />
            <path d="M28 28 C18 40 10 48 6 48 C6 36 14 28 28 28Z" />
            <path d="M28 28 C8 30 2 24 4 18 C10 14 20 20 28 28Z" />
            <path d="M28 28 C14 18 8 10 8 4 C16 4 22 14 28 28Z" />
            {/* ── Middle petals ── */}
            <path d="M28 28 C22 18 16 14 14 18 C16 24 22 26 28 28Z" />
            <path d="M28 28 C34 16 42 14 44 20 C40 26 32 26 28 28Z" />
            <path d="M28 28 C38 30 42 38 38 44 C30 40 26 32 28 28Z" />
            <path d="M28 28 C26 38 18 44 14 42 C12 34 18 28 28 28Z" />
            <path d="M28 28 C14 24 10 18 12 14 C18 14 22 22 28 28Z" />
            {/* ── Inner center ── */}
            <ellipse cx="28" cy="28" rx="7" ry="6" />
            <ellipse cx="28" cy="28" rx="3.5" ry="3" />
            {/* ── Main stem ── */}
            <path d="M36 36 Q58 58 88 88 Q118 118 148 152 Q158 164 166 174" />
            {/* ── Side branch ── */}
            <path d="M88 88 Q78 100 68 110" />
            {/* ── Leaf 1 ── */}
            <path d="M72 74 Q52 66 44 50 Q54 46 64 60 Q70 68 72 74Z" />
            <path d="M72 74 Q54 64 48 50" />
            {/* ── Small bud ── */}
            <path d="M88 88 Q80 76 78 64 Q86 66 88 78 Q88 84 88 88Z" />
            <path d="M88 88 C84 76 90 64 96 66 C96 78 92 86 88 88Z" />
            {/* ── Leaf 2 ── */}
            <path d="M116 120 Q130 104 136 86 Q124 84 118 100 Q114 110 116 120Z" />
            <path d="M116 120 Q128 106 134 88" />
            {/* ── Leaf near end ── */}
            <path d="M148 152 Q136 146 130 136 Q140 132 144 144 Q148 150 148 152Z" />
            {/* ── Corner sprigs ── */}
            <path d="M166 174 Q156 164 150 154 Q158 152 162 162 Q166 170 166 174Z" />
            <path d="M166 174 Q176 164 178 152 Q170 152 166 164 Q164 170 166 174Z" />
        </g>
    </svg>
);

/** Card wrapper: parchment background · gold double border · 4 peony corners */
const BotanicalCard = ({ className = '', children, style }) => (
    <div className={`jc-botanical-card ${className}`} style={style}>
        <span className="jc-bc-tl" aria-hidden="true"><BotanicalCornerSVG /></span>
        <span className="jc-bc-tr" aria-hidden="true"><BotanicalCornerSVG /></span>
        <span className="jc-bc-bl" aria-hidden="true"><BotanicalCornerSVG /></span>
        <span className="jc-bc-br" aria-hidden="true"><BotanicalCornerSVG /></span>
        <div className="jc-bc-content">{children}</div>
    </div>
);

/** Botanical floral illustration for Gift Guide section */
const GiftFloralSVG = () => (
    <svg className="jc-gift-floral" viewBox="0 0 220 280" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* ── Gold sparkles ── */}
        <path d="M42 38 L44 32 L46 38 L52 40 L46 42 L44 48 L42 42 L36 40Z" fill="#C8902A" opacity="0.85" />
        <path d="M170 20 L171.5 15 L173 20 L178 21.5 L173 23 L171.5 28 L170 23 L165 21.5Z" fill="#C8902A" opacity="0.75" />
        <path d="M192 130 L193 126 L194 130 L198 131 L194 132 L193 136 L192 132 L188 131Z" fill="#C8902A" opacity="0.70" />
        <path d="M28 195 L29.5 190 L31 195 L36 196.5 L31 198 L29.5 203 L28 198 L23 196.5Z" fill="#C8902A" opacity="0.70" />
        {/* ── Main stem ── */}
        <path d="M100 260 Q95 220 98 180 Q102 140 105 100 Q108 65 110 40" stroke="#B8821F" strokeWidth="2" strokeLinecap="round" />
        {/* ── Left large leaf ── */}
        <path d="M98 180 Q70 175 52 158 Q60 140 85 152 Q95 160 98 180Z" fill="#8B9E8A" opacity="0.80" />
        <path d="M98 180 Q70 170 54 156" stroke="#B8821F" strokeWidth="0.9" strokeLinecap="round" />
        {/* ── Right large leaf ── */}
        <path d="M104 155 Q132 148 148 130 Q140 114 118 124 Q106 134 104 155Z" fill="#8B9E8A" opacity="0.80" />
        <path d="M104 155 Q130 146 146 130" stroke="#B8821F" strokeWidth="0.9" strokeLinecap="round" />
        {/* ── Lower left small leaf ── */}
        <path d="M99 210 Q76 208 62 196 Q68 183 88 192 Q97 200 99 210Z" fill="#8B9E8A" opacity="0.65" />
        <path d="M99 210 Q78 206 64 195" stroke="#B8821F" strokeWidth="0.8" strokeLinecap="round" />
        {/* ── Right berry cluster ── */}
        <path d="M106 120 Q122 108 136 98" stroke="#B8821F" strokeWidth="1.2" strokeLinecap="round" />
        <circle cx="136" cy="97" r="5" fill="#C8902A" opacity="0.75" />
        <circle cx="146" cy="90" r="4" fill="#C8902A" opacity="0.65" />
        <circle cx="152" cy="100" r="3.5" fill="#C8902A" opacity="0.60" />
        {/* ── Left berry cluster ── */}
        <path d="M100 140 Q82 128 68 116" stroke="#B8821F" strokeWidth="1.2" strokeLinecap="round" />
        <circle cx="67" cy="115" r="4.5" fill="#C8902A" opacity="0.65" />
        <circle cx="57" cy="109" r="3.5" fill="#C8902A" opacity="0.55" />
        {/* ── Flower bud right ── */}
        <path d="M108 68 Q126 60 138 50" stroke="#B8821F" strokeWidth="1.2" strokeLinecap="round" />
        <path d="M138 50 Q140 42 136 38 Q132 36 130 42 Q128 48 134 52 Q136 54 138 50Z" fill="#F5E6D0" stroke="#B8821F" strokeWidth="0.8" />
        {/* ── Main flower (5 petals) ── */}
        <ellipse cx="110" cy="30" rx="13" ry="20" fill="#F5E6D0" stroke="#B8821F" strokeWidth="0.8" transform="rotate(-20 110 30)" />
        <ellipse cx="110" cy="30" rx="13" ry="20" fill="#F5E6D0" stroke="#B8821F" strokeWidth="0.8" transform="rotate(52 110 30)" />
        <ellipse cx="110" cy="30" rx="13" ry="20" fill="#F5E6D0" stroke="#B8821F" strokeWidth="0.8" transform="rotate(124 110 30)" />
        <ellipse cx="110" cy="30" rx="13" ry="20" fill="#F5E6D0" stroke="#B8821F" strokeWidth="0.8" transform="rotate(196 110 30)" />
        <ellipse cx="110" cy="30" rx="13" ry="20" fill="#F5E6D0" stroke="#B8821F" strokeWidth="0.8" transform="rotate(268 110 30)" />
        {/* ── Flower center ── */}
        <circle cx="110" cy="30" r="10" fill="#D4A843" />
        <circle cx="110" cy="30" r="7" fill="#E8BE60" />
        {/* ── Flower stamen lines ── */}
        <line x1="110" y1="23" x2="110" y2="26" stroke="#B8821F" strokeWidth="0.8" />
        <line x1="115" y1="25" x2="113" y2="27" stroke="#B8821F" strokeWidth="0.8" />
        <line x1="114" y1="32" x2="112" y2="31" stroke="#B8821F" strokeWidth="0.8" />
        <line x1="110" y1="36" x2="110" y2="33" stroke="#B8821F" strokeWidth="0.8" />
        <line x1="106" y1="32" x2="108" y2="31" stroke="#B8821F" strokeWidth="0.8" />
        <line x1="105" y1="25" x2="107" y2="27" stroke="#B8821F" strokeWidth="0.8" />
    </svg>
);

/** Gold ornamental divider — matching the reference image */
const OrnamentDivider = () => (
    <div className="jc-ornament-divider" aria-hidden="true">
        <svg viewBox="0 0 140 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0" y1="10" x2="52" y2="10" stroke="currentColor" strokeWidth="0.8" />
            <path d="M56 10 L62 4 L68 10 L62 16Z" stroke="currentColor" strokeWidth="0.8" fill="currentColor" fillOpacity="0.25" />
            <circle cx="70" cy="10" r="2.5" fill="currentColor" />
            <path d="M72 10 L78 4 L84 10 L78 16Z" stroke="currentColor" strokeWidth="0.8" fill="currentColor" fillOpacity="0.25" />
            <line x1="88" y1="10" x2="140" y2="10" stroke="currentColor" strokeWidth="0.8" />
        </svg>
    </div>
);

/* ═══════════════════════════════════════════════════════════════════════
   MAIN COMPONENT
   ═══════════════════════════════════════════════════════════════════════ */
export default function JenineCharisseBirthday() {
    const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [entered, setEntered] = useState(false);
    const [splashExiting, setSplashExiting] = useState(false);
    const [musicPlaying, setMusicPlaying] = useState(false);
    const [activeTab, setActiveTab] = useState('roses');
    const [lightbox, setLightbox] = useState(null); // index of open photo (celebrant grid)
    const [lightbox2, setLightbox2] = useState(null); // index of open photo (strip gallery)
    const [openFaq, setOpenFaq] = useState(null);
    const [rsvpData, setRsvpData] = useState({ name: '', email: '', phone: '', guests: '1', attendance: '', message: '' });
    const [rsvpSubmitted, setRsvpSubmitted] = useState(false);
    const [rsvpLoading, setRsvpLoading] = useState(false);
    const [rsvpError, setRsvpError] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});

    const audioRef = useRef(null);
    const carouselRef = useRef(null);
    const dragState = useRef({ active: false, startX: 0, startTranslate: 0 });
    const galleryPhotos = [gallery1, gallery3, gallery8, galleryImg422];
    const stripPhotos = [gallery4, gallery5, galleryImg240, gallery7, galleryImg422];

    /* ── Carousel drag-to-scroll ────────────────────────────────────── */
    const getCarouselTranslateX = () => {
        const el = carouselRef.current;
        if (!el) return 0;
        return new DOMMatrix(getComputedStyle(el).transform).m41;
    };
    const onCarouselDragStart = (clientX) => {
        const el = carouselRef.current;
        if (!el) return;
        const currentX = getCarouselTranslateX();
        el.style.animationPlayState = 'paused';
        el.style.transform = `translateX(${currentX}px)`;
        el.style.cursor = 'grabbing';
        dragState.current = { active: true, startX: clientX, startTranslate: currentX };
    };
    const onCarouselDragMove = (clientX) => {
        if (!dragState.current.active) return;
        const el = carouselRef.current;
        if (!el) return;
        const dx = clientX - dragState.current.startX;
        el.style.transform = `translateX(${dragState.current.startTranslate + dx}px)`;
    };
    const onCarouselDragEnd = () => {
        if (!dragState.current.active) return;
        dragState.current.active = false;
        const el = carouselRef.current;
        if (!el) return;
        el.style.cursor = '';
        el.style.transform = '';
        el.style.animationPlayState = 'running';
    };

    /* ── Gallery lightbox keyboard nav ─────────────────────────────── */
    useEffect(() => {
        if (lightbox === null) return;
        const onKey = (e) => {
            if (e.key === 'Escape') setLightbox(null);
            if (e.key === 'ArrowRight') setLightbox(i => (i + 1) % galleryPhotos.length);
            if (e.key === 'ArrowLeft') setLightbox(i => (i - 1 + galleryPhotos.length) % galleryPhotos.length);
        };
        window.addEventListener('keydown', onKey);
        document.body.style.overflow = 'hidden';
        return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
    }, [lightbox, galleryPhotos.length]);

    /* ── Strip lightbox keyboard nav ───────────────────────────────── */
    useEffect(() => {
        if (lightbox2 === null) return;
        const onKey = (e) => {
            if (e.key === 'Escape') setLightbox2(null);
            if (e.key === 'ArrowRight') setLightbox2(i => (i + 1) % stripPhotos.length);
            if (e.key === 'ArrowLeft') setLightbox2(i => (i - 1 + stripPhotos.length) % stripPhotos.length);
        };
        window.addEventListener('keydown', onKey);
        document.body.style.overflow = 'hidden';
        return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
    }, [lightbox2, stripPhotos.length]);

    /* ── Countdown ──────────────────────────────────────────────────── */
    useEffect(() => {
        const tick = () => {
            const diff = EVENT_DATE - new Date();
            if (diff <= 0) { setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 }); return; }
            setCountdown({
                days: Math.floor(diff / 86_400_000),
                hours: Math.floor((diff % 86_400_000) / 3_600_000),
                minutes: Math.floor((diff % 3_600_000) / 60_000),
                seconds: Math.floor((diff % 60_000) / 1_000),
            });
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, []);

    /* ── Scroll Reveal ──────────────────────────────────────────────── */
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('jc-visible'); observer.unobserve(e.target); } }),
            { threshold: 0.08 }
        );
        document.querySelectorAll('.jc-reveal, .jc-reveal-left, .jc-reveal-right').forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, [activeTab]);

    /* ── Keyboard ───────────────────────────────────────────────────── */
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') setOpenFaq(null); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, []);

    /* ── Enter / Audio ──────────────────────────────────────────────── */
    const handleEnter = useCallback(() => {
        if (splashExiting) return;
        setSplashExiting(true);
        const audio = audioRef.current;
        if (audio) audio.play().then(() => setMusicPlaying(true)).catch(() => { });
        setTimeout(() => setEntered(true), 900);
    }, [splashExiting]);

    const toggleMusic = useCallback(() => {
        const audio = audioRef.current;
        if (!audio) return;
        if (musicPlaying) { audio.pause(); setMusicPlaying(false); }
        else { audio.play().then(() => setMusicPlaying(true)).catch(() => { }); }
    }, [musicPlaying]);

    const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

    /* ── RSVP Submit ────────────────────────────────────────────────── */
    const handleRsvpSubmit = async (e) => {
        e.preventDefault();
        const errors = {};
        if (!rsvpData.name.trim() || rsvpData.name.trim().length < 2)
            errors.name = 'Please enter your full name (at least 2 characters).';
        if (rsvpData.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(rsvpData.email.trim()))
            errors.email = 'Please enter a valid email address.';
        if (rsvpData.phone.trim() && !/^[\d\s+\-().]{7,20}$/.test(rsvpData.phone.trim()))
            errors.phone = 'Please enter a valid phone number.';
        if (!rsvpData.attendance)
            errors.attendance = 'Please let us know if you will be attending.';
        if (Object.keys(errors).length > 0) { setFieldErrors(errors); return; }

        setFieldErrors({});
        setRsvpLoading(true);
        setRsvpError('');
        try {
            const res = await fetch(`${API_BASE_URL}/rsvp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    invitationId: 'birthday-jenine-charisse',
                    name: rsvpData.name.trim(),
                    email: rsvpData.email.trim(),
                    phone: rsvpData.phone.trim(),
                    guests: rsvpData.guests,
                    attending: rsvpData.attendance,
                    message: rsvpData.message.trim(),
                }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || 'Submission failed. Please try again.');
            setRsvpSubmitted(true);
        } catch (err) {
            setRsvpError(err.message || 'Something went wrong. Please try again or contact the family directly.');
        } finally {
            setRsvpLoading(false);
        }
    };

    /* ── Tradition configs ──────────────────────────────────────────── */
    const traditions = {
        roses: {
            label: '18 Roses', icon: '🌹',
            desc: 'Eighteen men who will each present a rose to the celebrant, symbolizing admiration, respect, and good wishes for her journey into womanhood.',
            names: rosesList,
        },
        candles: {
            label: '18 Candles', icon: '🕯️',
            desc: 'Eighteen meaningful lights from those who illuminate her path forward. Each candle carries a wish and a prayer for the birthday celebrant.',
            names: candlesList,
        },
        shots: {
            label: '18 Shots', icon: '🥂',
            desc: 'Eighteen toasts from eighteen special people — each raising a glass to celebrate Jenine Charisse and wish her a life full of joy, love, and adventure.',
            names: shotsList,
        },
        bills: {
            label: '18 Bills', icon: '💵',
            desc: 'Eighteen tokens of generosity and love, each representing the support and blessings of someone special in her life.',
            names: billsList,
        },
    };

    /* ══════════════════════════════════════════════════════════════════
       RENDER
       ══════════════════════════════════════════════════════════════════ */
    return (
        <div className="jc-page">

            {/* ── Splash ──────────────────────────────────────────────────── */}
            {!entered && (
                <div className={`jc-splash${splashExiting ? ' jc-splash--exiting' : ''}`} onClick={handleEnter}>
                    {/* Left gate panel */}
                    <div className="jc-gate jc-gate-left" aria-hidden="true">
                        <div className="jc-splash-particles">
                            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="jc-splash-particle" />)}
                        </div>
                    </div>
                    {/* Right gate panel */}
                    <div className="jc-gate jc-gate-right" aria-hidden="true">
                        <div className="jc-splash-particles">
                            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="jc-splash-particle" />)}
                        </div>
                    </div>
                    {/* Center seam */}
                    <div className="jc-splash-content">
                        <span className="jc-splash-tag">You are warmly invited to celebrate</span>
                        <h1 className="jc-splash-name">Jenine Charisse</h1>
                        <p className="jc-splash-subtitle">turns <em>eighteen</em></p>
                        <p className="jc-splash-theme">An Enchanted Garden Birthday</p>
                        <button className="jc-splash-btn" onClick={handleEnter}>
                            Enter the Garden &nbsp;✦
                        </button>
                        <p className="jc-splash-note">Click anywhere to enter</p>
                    </div>
                </div>
            )}

            {/* ── Ambient Particles ───────────────────────────────────────── */}
            <div className="jc-particles" aria-hidden="true">
                {Array.from({ length: 12 }).map((_, i) => <div key={i} className="jc-particle" />)}
            </div>

            {/* ── Music Button ────────────────────────────────────────────── */}
            <button
                className={`jc-music-btn${musicPlaying ? ' playing' : ''}`}
                onClick={toggleMusic}
                aria-label={musicPlaying ? 'Pause background music' : 'Play background music'}
            >
                <span className="jc-music-icon">{musicPlaying ? '♫' : '♪'}</span>
            </button>
            <audio ref={audioRef} loop preload="auto">
                <source src={bgMusic} type="audio/mpeg" />
            </audio>

            {/* ══════════════════════════════════════════════════════════════
          1. HERO
         ══════════════════════════════════════════════════════════════ */}
            <section id="hero" className="jc-hero"
                style={{ '--jc-hero-photo': `url(${charissePicture})` }}>
                <div className="jc-hero-overlay" aria-hidden="true" />
                <div className="jc-hero-content">
                    <h1 className="jc-hero-name">Jenine Charisse</h1>
                    <p className="jc-hero-turns">Turns Eighteen</p>
                    <p className="jc-hero-theme">✦ &nbsp; An Enchanted Garden Birthday &nbsp; ✦</p>
                    <div className="jc-hero-meta">
                        <span>Sunday &nbsp;·&nbsp; May 24, 2026 &nbsp;·&nbsp; 4:00 PM</span>
                        <span>Palacio's Event Place</span>
                    </div>
                </div>
                <div className="jc-hero-scroll" aria-hidden="true">
                    <div className="jc-hero-scroll-line" />
                    <span>Scroll</span>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          2. COUNTDOWN
         ══════════════════════════════════════════════════════════════ */}
            <section id="countdown" className="jc-section jc-countdown-section">
                <div className="jc-container jc-countdown-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-countdown-script">Counting down to the celebration</span>
                        <h2 className="jc-countdown-title">The Party Begins In</h2>
                        <div className="jc-countdown-mini-divider" aria-hidden="true">
                            <svg viewBox="0 0 120 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="0" y1="7" x2="48" y2="7" stroke="#B8923F" strokeWidth="0.8" />
                                <path d="M52 7 L60 1 L68 7 L60 13 Z" fill="#8B9E8A" stroke="#8B9E8A" strokeWidth="0.6" />
                                <circle cx="60" cy="7" r="1.4" fill="#B8923F" />
                                <line x1="72" y1="7" x2="120" y2="7" stroke="#B8923F" strokeWidth="0.8" />
                            </svg>
                        </div>
                    </div>
                    <div className="jc-countdown-grid">
                        {[
                            { num: countdown.days, label: 'Days' },
                            { num: countdown.hours, label: 'Hours' },
                            { num: countdown.minutes, label: 'Minutes' },
                            { num: countdown.seconds, label: 'Seconds' },
                        ].map(({ num, label }, i) => (
                            <div
                                key={label}
                                className="jc-countdown-card jc-reveal"
                                style={{
                                    transitionDelay: `${0.10 + i * 0.08}s`,
                                    '--jc-countdown-card-bg': `url(${countdownTimerCardBg})`,
                                }}
                            >
                                <div className="jc-countdown-card-inner">
                                    <span className="jc-countdown-num">{String(num).padStart(2, '0')}</span>
                                    <span className="jc-countdown-mini" aria-hidden="true">
                                        <svg viewBox="0 0 60 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <line x1="0" y1="5" x2="22" y2="5" stroke="#B8923F" strokeWidth="0.6" />
                                            <path d="M24 5 L30 1 L36 5 L30 9 Z" fill="#8B9E8A" stroke="#8B9E8A" strokeWidth="0.5" />
                                            <line x1="38" y1="5" x2="60" y2="5" stroke="#B8923F" strokeWidth="0.6" />
                                        </svg>
                                    </span>
                                    <span className="jc-countdown-label-pill">
                                        <span className="jc-countdown-label-text">{label}</span>
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          3. WELCOME
         ══════════════════════════════════════════════════════════════ */}
            <section id="welcome" className="jc-section jc-welcome-section">
                <div className="jc-container jc-welcome-inner">
                    <div className="jc-reveal">
                        <span className="jc-section-tag">A message from the heart</span>
                        <h2 className="jc-section-title">Dear Beloved Guests,</h2>
                        <OrnamentDivider />
                    </div>
                    <p className="jc-welcome-text jc-reveal" style={{ transitionDelay: '0.10s' }}>
                        With hearts full of joy and gratitude, we invite you to witness a once-in-a-lifetime milestone —
                        the blossoming of a remarkable young woman into all she is beautifully meant to be.
                    </p>
                    <p className="jc-welcome-text jc-reveal" style={{ transitionDelay: '0.18s' }}>
                        <strong>Jenine Charisse</strong> is turning eighteen, and on this enchanted afternoon, we celebrate
                        not merely a birthday, but the beginning of a radiant new chapter — a story written in grace,
                        in laughter, and in love that will last a lifetime.
                    </p>
                    <p className="jc-welcome-quote jc-reveal" style={{ transitionDelay: '0.26s' }}>
                        "She blooms in the most enchanted garden,<br />
                        and the whole world lights up around her."
                    </p>
                    <p className="jc-welcome-text jc-reveal" style={{ transitionDelay: '0.34s' }}>
                        You have been chosen to be part of this magical afternoon — not merely as a witness,
                        but as a cherished soul whose warmth, prayers, and well-wishes mean everything
                        to her and to our family.
                    </p>
                    <p className="jc-welcome-text jc-reveal" style={{ transitionDelay: '0.42s', textAlign: 'center', marginTop: '8px' }}>
                        With all our love,
                        <br />
                        <img src={motherFatherCursiveName} alt="Alfred Franz & Jennifer Claire" className="jc-welcome-signature-img" />
                    </p>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          4. GALLERY
         ══════════════════════════════════════════════════════════════ */}
            <section id="gallery" className="jc-section jc-gallery-section">
                <div className="jc-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-section-tag">A glimpse of the celebrant</span>
                        <h2 className="jc-section-title">Jenine Charisse</h2>
                        <OrnamentDivider />
                    </div>
                    <div className="jc-gallery-grid jc-reveal">
                        {galleryPhotos.map((src, i) => (
                            <div key={i} className="jc-gallery-item" onClick={() => setLightbox(i)} role="button" tabIndex={0}
                                onKeyDown={e => e.key === 'Enter' && setLightbox(i)} aria-label={`View photo ${i + 1}`}>
                                <img src={src} alt={`Jenine Charisse photo ${i + 1}`} loading="lazy" />
                                <div className="jc-gallery-hover" aria-hidden="true">
                                    <svg className="jc-gallery-flower" viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        {/* Stem */}
                                        <path d="M40 62 Q38 78 36 92" stroke="#8FAF7E" strokeWidth="2.5" strokeLinecap="round" />
                                        {/* Left leaf */}
                                        <path d="M38 76 Q28 70 26 62 Q34 64 38 76Z" fill="#8FAF7E" />
                                        {/* Right leaf */}
                                        <path d="M37 82 Q48 78 50 70 Q42 70 37 82Z" fill="#8FAF7E" />
                                        {/* Petals — 8 rounded petals */}
                                        <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F5E6D0" />
                                        <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F0DEC5" transform="rotate(45 40 45)" />
                                        <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F5E6D0" transform="rotate(90 40 45)" />
                                        <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F0DEC5" transform="rotate(135 40 45)" />
                                        <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F5E6D0" transform="rotate(180 40 45)" />
                                        <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F0DEC5" transform="rotate(225 40 45)" />
                                        <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F5E6D0" transform="rotate(270 40 45)" />
                                        <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F0DEC5" transform="rotate(315 40 45)" />
                                        {/* Center */}
                                        <circle cx="40" cy="45" r="9" fill="#D4A843" />
                                        <circle cx="40" cy="45" r="6" fill="#F0C040" />
                                        {/* Center dots */}
                                        <circle cx="40" cy="39" r="1.2" fill="#C8902A" />
                                        <circle cx="45" cy="42" r="1.2" fill="#C8902A" />
                                        <circle cx="45" cy="48" r="1.2" fill="#C8902A" />
                                        <circle cx="40" cy="51" r="1.2" fill="#C8902A" />
                                        <circle cx="35" cy="48" r="1.2" fill="#C8902A" />
                                        <circle cx="35" cy="42" r="1.2" fill="#C8902A" />
                                    </svg>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* ── Lightbox Modal ──────────────────────────────────── */}
                    {lightbox !== null && (
                        <div className="jc-lightbox" onClick={() => setLightbox(null)} role="dialog" aria-modal="true">
                            <button className="jc-lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">×</button>
                            <button className="jc-lightbox-prev" onClick={e => { e.stopPropagation(); setLightbox(i => (i - 1 + galleryPhotos.length) % galleryPhotos.length); }} aria-label="Previous">‹</button>
                            <div className="jc-lightbox-img-wrap" onClick={e => e.stopPropagation()}>
                                <img src={galleryPhotos[lightbox]} alt={`Jenine Charisse photo ${lightbox + 1}`} />
                                <span className="jc-lightbox-counter">{lightbox + 1} / {galleryPhotos.length}</span>
                            </div>
                            <button className="jc-lightbox-next" onClick={e => { e.stopPropagation(); setLightbox(i => (i + 1) % galleryPhotos.length); }} aria-label="Next">›</button>
                        </div>
                    )}
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          3b. PHOTO GALLERY STRIP
         ══════════════════════════════════════════════════════════════ */}
            <section className="jc-section jc-strip-section">
                <div className="jc-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-section-tag">More moments to cherish</span>
                        <h2 className="jc-section-title">Photo Gallery</h2>
                        <OrnamentDivider />
                    </div>
                    <div className="jc-carousel-mask">
                        <div
                            className="jc-carousel-track"
                            ref={carouselRef}
                            onMouseDown={e => { e.preventDefault(); onCarouselDragStart(e.clientX); }}
                            onMouseMove={e => onCarouselDragMove(e.clientX)}
                            onMouseUp={onCarouselDragEnd}
                            onMouseLeave={onCarouselDragEnd}
                            onTouchStart={e => onCarouselDragStart(e.touches[0].clientX)}
                            onTouchMove={e => { e.preventDefault(); onCarouselDragMove(e.touches[0].clientX); }}
                            onTouchEnd={onCarouselDragEnd}
                        >
                            {[...stripPhotos, ...stripPhotos].map((src, i) => (
                                <div key={i} className="jc-strip-item"
                                    onClick={() => setLightbox2(i % stripPhotos.length)}
                                    role="button" tabIndex={0}
                                    onKeyDown={e => e.key === 'Enter' && setLightbox2(i % stripPhotos.length)}
                                    aria-label={`View photo ${(i % stripPhotos.length) + 1}`}>
                                    <img src={src} alt={`Jenine Charisse gallery photo ${(i % stripPhotos.length) + 1}`} loading="lazy" />
                                    <div className="jc-gallery-hover" aria-hidden="true">
                                        <svg className="jc-gallery-flower" viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M40 62 Q38 78 36 92" stroke="#8FAF7E" strokeWidth="2.5" strokeLinecap="round" />
                                            <path d="M38 76 Q28 70 26 62 Q34 64 38 76Z" fill="#8FAF7E" />
                                            <path d="M37 82 Q48 78 50 70 Q42 70 37 82Z" fill="#8FAF7E" />
                                            <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F5E6D0" />
                                            <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F0DEC5" transform="rotate(45 40 45)" />
                                            <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F5E6D0" transform="rotate(90 40 45)" />
                                            <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F0DEC5" transform="rotate(135 40 45)" />
                                            <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F5E6D0" transform="rotate(180 40 45)" />
                                            <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F0DEC5" transform="rotate(225 40 45)" />
                                            <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F5E6D0" transform="rotate(270 40 45)" />
                                            <ellipse cx="40" cy="28" rx="6" ry="13" fill="#F0DEC5" transform="rotate(315 40 45)" />
                                            <circle cx="40" cy="45" r="9" fill="#D4A843" />
                                            <circle cx="40" cy="45" r="6" fill="#F0C040" />
                                            <circle cx="40" cy="39" r="1.2" fill="#C8902A" />
                                            <circle cx="45" cy="42" r="1.2" fill="#C8902A" />
                                            <circle cx="45" cy="48" r="1.2" fill="#C8902A" />
                                            <circle cx="40" cy="51" r="1.2" fill="#C8902A" />
                                            <circle cx="35" cy="48" r="1.2" fill="#C8902A" />
                                            <circle cx="35" cy="42" r="1.2" fill="#C8902A" />
                                        </svg>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* ── Strip Lightbox ─────────────────────────────────── */}
                    {lightbox2 !== null && (
                        <div className="jc-lightbox" onClick={() => setLightbox2(null)} role="dialog" aria-modal="true">
                            <button className="jc-lightbox-close" onClick={() => setLightbox2(null)} aria-label="Close">×</button>
                            <button className="jc-lightbox-prev" onClick={e => { e.stopPropagation(); setLightbox2(i => (i - 1 + stripPhotos.length) % stripPhotos.length); }} aria-label="Previous">‹</button>
                            <div className="jc-lightbox-img-wrap" onClick={e => e.stopPropagation()}>
                                <img src={stripPhotos[lightbox2]} alt={`Jenine Charisse gallery photo ${lightbox2 + 1}`} />
                                <span className="jc-lightbox-counter">{lightbox2 + 1} / {stripPhotos.length}</span>
                            </div>
                            <button className="jc-lightbox-next" onClick={e => { e.stopPropagation(); setLightbox2(i => (i + 1) % stripPhotos.length); }} aria-label="Next">›</button>
                        </div>
                    )}
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          5. EVENT DETAILS
         ══════════════════════════════════════════════════════════════ */}
            <section id="details" className="jc-section jc-details-section"
                style={{ '--jc-details-bg': `url(${celebrationDetailsBg})` }}>
                <div className="jc-container">
                    <div className="jc-details-card jc-reveal">
                        <div className="jc-details-header">
                            <span className="jc-details-kicker">All The Beautiful Details</span>
                            <h2 className="jc-details-title">Celebration Details</h2>
                            <div className="jc-details-divider" aria-hidden="true">
                                <svg viewBox="0 0 180 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0" y1="12" x2="58" y2="12" stroke="#D1A33D" strokeWidth="0.9" />
                                    <path d="M90 2 C86 6 84 10 84 12 C84 14 86 18 90 22" stroke="#D1A33D" strokeWidth="1" strokeLinecap="round" />
                                    <path d="M90 2 C94 6 96 10 96 12 C96 14 94 18 90 22" stroke="#D1A33D" strokeWidth="1" strokeLinecap="round" />
                                    <circle cx="90" cy="12" r="2.1" fill="#D1A33D" />
                                    <line x1="122" y1="12" x2="180" y2="12" stroke="#D1A33D" strokeWidth="0.9" />
                                </svg>
                            </div>
                        </div>

                        <div className="jc-details-panel">
                            <div className="jc-details-celebrant">
                                <span className="jc-details-honor">In Honor Of</span>
                                <img src={cursiveName} alt="Jenine Charisse" className="jc-details-celebrant-name" />
                                <div className="jc-details-mini-divider" aria-hidden="true">
                                    <svg viewBox="0 0 140 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="0" y1="9" x2="60" y2="9" stroke="#D1A33D" strokeWidth="0.8" />
                                        <path d="M66 9 L70 5 L74 9 L70 13 Z" fill="#D1A33D" />
                                        <line x1="80" y1="9" x2="140" y2="9" stroke="#D1A33D" strokeWidth="0.8" />
                                    </svg>
                                </div>
                            </div>

                            <div className="jc-details-grid">
                                <div className="jc-detail-item">
                                    <span className="jc-detail-icon" aria-hidden="true">◫</span>
                                    <span className="jc-detail-label">Date</span>
                                    <span className="jc-detail-sep" aria-hidden="true" />
                                    <span className="jc-detail-value">Sunday, May 24, 2026</span>
                                </div>
                                <div className="jc-detail-item">
                                    <span className="jc-detail-icon" aria-hidden="true">◔</span>
                                    <span className="jc-detail-label">Time</span>
                                    <span className="jc-detail-sep" aria-hidden="true" />
                                    <span className="jc-detail-value">4:00 PM</span>
                                </div>
                                <div className="jc-detail-item">
                                    <span className="jc-detail-icon" aria-hidden="true">⌖</span>
                                    <span className="jc-detail-label">Venue</span>
                                    <span className="jc-detail-sep" aria-hidden="true" />
                                    <span className="jc-detail-value">Palacio's Event Place</span>
                                </div>
                                <div className="jc-detail-item">
                                    <span className="jc-detail-icon" aria-hidden="true">❦</span>
                                    <span className="jc-detail-label">Theme</span>
                                    <span className="jc-detail-sep" aria-hidden="true" />
                                    <span className="jc-detail-value">Enchanted Garden</span>
                                </div>
                            </div>

                            <div className="jc-details-family-divider" aria-hidden="true">
                                <svg viewBox="0 0 160 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0" y1="10" x2="64" y2="10" stroke="#D1A33D" strokeWidth="0.8" />
                                    <path d="M80 2 C74 4 72 9 72 10 C72 11 74 16 80 18" stroke="#D1A33D" strokeWidth="0.9" strokeLinecap="round" />
                                    <path d="M80 2 C86 4 88 9 88 10 C88 11 86 16 80 18" stroke="#D1A33D" strokeWidth="0.9" strokeLinecap="round" />
                                    <line x1="96" y1="10" x2="160" y2="10" stroke="#D1A33D" strokeWidth="0.8" />
                                </svg>
                            </div>

                            <div className="jc-details-family">
                                <div className="jc-family-person">
                                    <span className="jc-family-role">Father</span>
                                    <span className="jc-family-name">Alfred Franz</span>
                                </div>
                                <div className="jc-family-divider" aria-hidden="true">✧</div>
                                <div className="jc-family-person">
                                    <span className="jc-family-role">Mother</span>
                                    <span className="jc-family-name">Jennifer Claire</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          5. DRESS CODE
         ══════════════════════════════════════════════════════════════ */}
            <section id="dresscode" className="jc-section jc-dresscode-section">
                <div className="jc-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-section-tag">Dress for the enchanted garden</span>
                        <h2 className="jc-section-title">Dress Code</h2>
                        <OrnamentDivider />
                    </div>
                    <div className="jc-dresscode-card jc-reveal">
                        <img src={dressCodeClipart} alt="Semi-formal attire illustration" className="jc-dresscode-img" aria-hidden="true" />
                        <h3 className="jc-dresscode-title">Semi-Formal Attire</h3>
                        <p className="jc-dresscode-text">
                            In the spirit of this enchanted garden celebration, guests are warmly invited to dress in
                            their finest semi-formal wear. Embrace the beauty of the occasion and grace the event with
                            elegance and style.
                        </p>
                        <p className="jc-dresscode-text">
                            Please note that this day is for our celebrant.{' '}
                            <strong>We advise you not to wear red or silver attire</strong> — any other color is perfectly
                            welcome. Let the garden inspire your ensemble!
                        </p>
                        <div className="jc-dresscode-pills">
                            <span className="jc-dresscode-pill ladies">👸 Ladies: Semi-Formal Dress</span>
                            <span className="jc-dresscode-pill gents">🤵 Gentlemen: Semi-Formal</span>
                            <span className="jc-dresscode-pill avoid">🚫 Avoid: Red &amp; Silver</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          6. TRADITIONS
         ══════════════════════════════════════════════════════════════ */}
            <section id="traditions" className="jc-section jc-traditions-section">
                <div className="jc-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-section-tag">A birthday full of tradition</span>
                        <h2 className="jc-section-title">Special Traditions</h2>
                        <OrnamentDivider />
                    </div>
                    <div className="jc-traditions-tabs jc-reveal">
                        {Object.entries(traditions).map(([key, { label, icon }]) => (
                            <button
                                key={key}
                                className={`jc-tab-btn${activeTab === key ? ' active' : ''}`}
                                onClick={() => setActiveTab(key)}
                                aria-pressed={activeTab === key}
                            >
                                {icon} {label}
                            </button>
                        ))}
                    </div>
                    <BotanicalCard className="jc-reveal">
                        {(() => {
                            const t = traditions[activeTab];
                            return (
                                <>
                                    <div className="jc-tradition-header">
                                        <span className="jc-tradition-icon" aria-hidden="true">{t.icon}</span>
                                        <h3 className="jc-tradition-title">{t.label}</h3>
                                        <p className="jc-tradition-desc">{t.desc}</p>
                                    </div>
                                    <ul className="jc-tradition-list" aria-label={`${t.label} participants`}>
                                        {t.names.map((name, i) => (
                                            <li key={i} className="jc-tradition-item jc-reveal" style={{ transitionDelay: `${i * 0.04}s` }}>
                                                <span className="jc-tradition-num" aria-hidden="true">{i + 1}</span>
                                                <span className="jc-tradition-name">{name}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <p className="jc-tradition-note">
                                        ✦ &nbsp; If you are part of the {t.label}, please prepare a short birthday message or wish.
                                        Write it in a letter and read it to her when your name is called.
                                    </p>
                                </>
                            );
                        })()}
                    </BotanicalCard>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          7. PROGRAM FLOW
         ══════════════════════════════════════════════════════════════ */}
            <section id="program-flow" className="jc-section jc-programflow-section">
                <div className="jc-container">
                    <div
                        className="jc-reveal jc-programflow-card"
                        style={{
                            '--jc-programflow-bg': `url(${programFlowBg})`,
                            '--jc-programflow-bg-mobile': `url(${programFlowBgMobile})`,
                            '--jc-programflow-bg-small-mobile': `url(${programFlowBgSmallMobile})`,
                        }}
                    >
                        <div className="jc-programflow-header">
                            <span className="jc-programflow-fleuron jc-programflow-fleuron-top" aria-hidden="true">
                                <svg viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 2 L23 7 L20 12 L17 7 Z" fill="#B8923F" />
                                    <path d="M20 12 Q14 14 8 12" stroke="#B8923F" strokeWidth="0.9" strokeLinecap="round" />
                                    <path d="M20 12 Q26 14 32 12" stroke="#B8923F" strokeWidth="0.9" strokeLinecap="round" />
                                    <circle cx="6" cy="12" r="1.2" fill="#B8923F" />
                                    <circle cx="34" cy="12" r="1.2" fill="#B8923F" />
                                </svg>
                            </span>
                            <h2 className="jc-programflow-title">Program Flow</h2>
                            <span className="jc-programflow-fleuron jc-programflow-fleuron-bot" aria-hidden="true">
                                <svg viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 22 L23 17 L20 12 L17 17 Z" fill="#B8923F" />
                                    <path d="M20 12 Q14 10 8 12" stroke="#B8923F" strokeWidth="0.9" strokeLinecap="round" />
                                    <path d="M20 12 Q26 10 32 12" stroke="#B8923F" strokeWidth="0.9" strokeLinecap="round" />
                                    <circle cx="6" cy="12" r="1.2" fill="#B8923F" />
                                    <circle cx="34" cy="12" r="1.2" fill="#B8923F" />
                                </svg>
                            </span>
                        </div>
                        <ol className="jc-programflow-list">
                            {programFlow.map((item, i) => (
                                <li key={i} className="jc-programflow-item">
                                    <span className="jc-programflow-num">{i + 1}</span>
                                    <span className="jc-programflow-text">{item}</span>
                                </li>
                            ))}
                        </ol>
                        <div className="jc-programflow-footer-ornament" aria-hidden="true">
                            <svg viewBox="0 0 100 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 8 Q20 2 30 8 Q40 14 50 8 Q60 2 70 8 Q80 14 90 8"
                                    stroke="#B8923F" strokeWidth="0.8" fill="none" strokeLinecap="round" />
                                <circle cx="50" cy="8" r="1.4" fill="#B8923F" />
                            </svg>
                        </div>
                    </div>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          8. VENUE
         ══════════════════════════════════════════════════════════════ */}
            <section id="venue" className="jc-section jc-venue-section">
                <div className="jc-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-section-tag">Find your way to the celebration</span>
                        <h2 className="jc-section-title">The Venue</h2>
                        <OrnamentDivider />
                    </div>
                    <BotanicalCard className="jc-reveal jc-venue-card">
                        <div className="jc-map-embed" aria-label="Palacio's Event Place">
                            <img src={palacioVenue} alt="Palacio's Event Place" className="jc-venue-photo" />
                        </div>
                        <div className="jc-venue-info">
                            <h3 className="jc-venue-name">Palacio's Event Place</h3>
                            <a
                                className="jc-venue-btn"
                                href="https://maps.app.goo.gl/A9QeSnZuGadjH2PT6"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="View venue on Google Maps"
                            >
                                🗺 &nbsp; View on Google Maps
                            </a>
                            <p className="jc-venue-note">✦ &nbsp; Ample parking is available for all guests</p>
                        </div>

                    </BotanicalCard>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          9. FAQ
         ══════════════════════════════════════════════════════════════ */}
            <section id="faq" className="jc-section jc-faq-section">
                <div className="jc-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-section-tag">Everything you need to know</span>
                        <h2 className="jc-section-title">Guest Reminders</h2>
                        <OrnamentDivider />
                    </div>
                    <div className="jc-reveal jc-reminder-block">
                        <p className="jc-reminder-text">
                            We have a coordinator who will assist you when you enter the Palacio. They will give you your seat number,
                            and please be seated once you receive your table number. A grazing table, mobile bar, and photobooth will be available.
                            There are more parking spaces, so there is no need to worry if you want to bring a car.
                        </p>
                        <p className="jc-reminder-text">
                            We would really appreciate it if you bring a letter to drop in the box that will be available on the
                            coordinators&rsquo; table, as the celebrant will be happy to read all your messages and wishes, especially
                            since it is something she can keep. If you are part of the 18 Candles, 18 Shots, or 18 Bills, please prepare a short
                            birthday message or wish for the celebrant. Write it in a letter, and you can read it to her once your
                            name is called. After that, you can place it in the same box.
                        </p>
                    </div>

                    <BotanicalCard className="jc-reveal jc-faq-card">
                        <div className="jc-faq-list" role="list">
                            {faqs.map((faq, i) => {
                                const isOpen = openFaq === i;
                                return (
                                    <div key={i} className="jc-faq-item" role="listitem">
                                        <button
                                            className="jc-faq-question"
                                            onClick={() => setOpenFaq(isOpen ? null : i)}
                                            aria-expanded={isOpen}
                                            aria-controls={`faq-answer-${i}`}
                                        >
                                            <span className="jc-faq-q-text">{faq.q}</span>
                                            <span className={`jc-faq-chevron${isOpen ? ' open' : ''}`} aria-hidden="true">▾</span>
                                        </button>
                                        <div
                                            id={`faq-answer-${i}`}
                                            className={`jc-faq-answer${isOpen ? ' open' : ''}`}
                                            role="region"
                                            aria-hidden={!isOpen}
                                        >
                                            <div className="jc-faq-answer-inner">{faq.a}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </BotanicalCard>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          10. GIFT GUIDE
         ══════════════════════════════════════════════════════════════ */}
            <section id="gift" className="jc-section jc-gift-section">
                <div className="jc-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-section-tag">A note from the celebrant</span>
                        <h2 className="jc-section-title">Gift Guide</h2>
                        <OrnamentDivider />
                    </div>
                    <BotanicalCard className="jc-reveal" style={{ textAlign: 'center' }}>
                        <img src={giftFloral} alt="Floral illustration" className="jc-gift-floral" />
                        <p className="jc-gift-quote">
                            "Your presence at my birthday party is the best birthday gift I could ask for!
                            If you feel comfortable giving more, a contribution to my Travel would be
                            greatly appreciated."
                        </p>
                        <p className="jc-gift-sub">— Jenine Charisse</p>
                        <div className="jc-gift-ornament">
                            <span>✦</span>
                            <span>Your love and presence are the greatest gift of all</span>
                            <span>✦</span>
                        </div>
                    </BotanicalCard>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          11. SPECIAL INSTRUCTIONS
         ══════════════════════════════════════════════════════════════ */}
            <section id="instructions" className="jc-section jc-instructions-section">
                <div className="jc-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-section-tag">A kind request from the family</span>
                        <h2 className="jc-section-title">Special Instructions</h2>
                        <OrnamentDivider />
                    </div>
                    <BotanicalCard className="jc-reveal">
                        <ul className="jc-instructions-list">
                            <li className="jc-instruction-item">
                                <span className="jc-instr-num">01</span>
                                <div className="jc-instr-body">
                                    <strong>Share the memories.</strong> We encourage everyone to take as many videos and photos as they like — it is a memorable moment for everyone! Please do not forget to send them to the Facebook account <strong>"Claire Nave."</strong>
                                </div>
                            </li>
                            <li className="jc-instruction-item">
                                <span className="jc-instr-num">02</span>
                                <div className="jc-instr-body">
                                    <strong>Drop a letter.</strong> We would really appreciate it if you bring a letter to drop in the box at the coordinator's table. The celebrant will be happy to read all your messages and wishes — especially since it is something she can keep.
                                </div>
                            </li>
                            <li className="jc-instruction-item">
                                <span className="jc-instr-num">03</span>
                                <div className="jc-instr-body">
                                    <strong>18 Candles, 18 Shots &amp; 18 Bills participants.</strong> Please prepare a short birthday message or wish. Write it in a letter and read it to her once your name is called. Then place it in the letter box.
                                </div>
                            </li>
                            <li className="jc-instruction-item">
                                <span className="jc-instr-num">04</span>
                                <div className="jc-instr-body">
                                    <strong>Upon arrival.</strong> A coordinator will assist you when you enter Palacio and will provide your table number. Please be seated once you receive it. A grazing table and photobooth will be available throughout the evening.
                                </div>
                            </li>
                        </ul>
                    </BotanicalCard>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          12. RSVP
         ══════════════════════════════════════════════════════════════ */}
            <section id="rsvp" className="jc-section jc-rsvp-section">
                <div className="jc-container">
                    <div className="jc-section-header jc-reveal">
                        <span className="jc-section-tag">Reserve your place in the garden</span>
                        <h2 className="jc-section-title">RSVP</h2>
                        <p className="jc-section-subtitle">
                            We would love to know you will be joining us. Kindly let us know at your earliest convenience.
                        </p>
                        <OrnamentDivider />
                    </div>
                    <BotanicalCard className="jc-reveal jc-rsvp-card">
                        {rsvpSubmitted ? (
                            <div className="jc-rsvp-success" role="alert">
                                <span className="jc-rsvp-success-icon" aria-hidden="true">✨</span>
                                <h3>Thank you so much!</h3>
                                <p>
                                    {rsvpData.attendance === 'yes'
                                        ? "We are so excited to celebrate with you! See you on May 24th at Palacio's!"
                                        : "We completely understand, and we will surely miss you. Thank you for letting us know — you will be in our hearts that day."}
                                </p>
                            </div>
                        ) : (
                            <form className="jc-form" onSubmit={handleRsvpSubmit} noValidate>
                                <div className="jc-form-row">
                                    <div className="jc-form-group">
                                        <label className="jc-form-label" htmlFor="rsvp-name">Full Name *</label>
                                        <input
                                            id="rsvp-name"
                                            className={`jc-form-input${fieldErrors.name ? ' jc-input-error' : ''}`}
                                            type="text"
                                            placeholder="Your full name"
                                            value={rsvpData.name}
                                            onChange={(e) => { setRsvpData({ ...rsvpData, name: e.target.value }); setFieldErrors((p) => ({ ...p, name: '' })); }}
                                            autoComplete="name"
                                        />
                                        {fieldErrors.name && <span className="jc-field-error">{fieldErrors.name}</span>}
                                    </div>
                                    <div className="jc-form-group">
                                        <label className="jc-form-label" htmlFor="rsvp-email">Email Address</label>
                                        <input
                                            id="rsvp-email"
                                            className={`jc-form-input${fieldErrors.email ? ' jc-input-error' : ''}`}
                                            type="email"
                                            placeholder="your@email.com"
                                            value={rsvpData.email}
                                            onChange={(e) => { setRsvpData({ ...rsvpData, email: e.target.value }); setFieldErrors((p) => ({ ...p, email: '' })); }}
                                            autoComplete="email"
                                        />
                                        {fieldErrors.email && <span className="jc-field-error">{fieldErrors.email}</span>}
                                    </div>
                                </div>

                                <div className="jc-form-row">
                                    <div className="jc-form-group">
                                        <label className="jc-form-label" htmlFor="rsvp-phone">Phone Number</label>
                                        <input
                                            id="rsvp-phone"
                                            className={`jc-form-input${fieldErrors.phone ? ' jc-input-error' : ''}`}
                                            type="tel"
                                            placeholder="+63 XXX XXX XXXX"
                                            value={rsvpData.phone}
                                            onChange={(e) => { setRsvpData({ ...rsvpData, phone: e.target.value }); setFieldErrors((p) => ({ ...p, phone: '' })); }}
                                            autoComplete="tel"
                                        />
                                        {fieldErrors.phone && <span className="jc-field-error">{fieldErrors.phone}</span>}
                                    </div>
                                    <div className="jc-form-group">
                                        <label className="jc-form-label" htmlFor="rsvp-guests">Number of Guests</label>
                                        <select
                                            id="rsvp-guests"
                                            className="jc-form-input jc-form-select"
                                            value={rsvpData.guests}
                                            onChange={(e) => setRsvpData({ ...rsvpData, guests: e.target.value })}
                                        >
                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                                                <option key={n} value={n}>{n} {n === 1 ? 'Guest' : 'Guests'}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="jc-form-group">
                                    <span className="jc-form-label" id="attendance-label">Will you be attending? *</span>
                                    <div className="jc-attendance-group" role="group" aria-labelledby="attendance-label">
                                        <button
                                            type="button"
                                            className={`jc-attendance-btn${rsvpData.attendance === 'yes' ? ' selected-yes' : ''}`}
                                            onClick={() => { setRsvpData({ ...rsvpData, attendance: 'yes' }); setFieldErrors((p) => ({ ...p, attendance: '' })); }}
                                            aria-pressed={rsvpData.attendance === 'yes'}
                                        >
                                            ✓ &nbsp; Yes, I'll be there!
                                        </button>
                                        <button
                                            type="button"
                                            className={`jc-attendance-btn${rsvpData.attendance === 'no' ? ' selected-no' : ''}`}
                                            onClick={() => { setRsvpData({ ...rsvpData, attendance: 'no' }); setFieldErrors((p) => ({ ...p, attendance: '' })); }}
                                            aria-pressed={rsvpData.attendance === 'no'}
                                        >
                                            ✗ &nbsp; Sorry, I can't make it
                                        </button>
                                    </div>
                                    {fieldErrors.attendance && <span className="jc-field-error">{fieldErrors.attendance}</span>}
                                </div>

                                <div className="jc-form-group">
                                    <label className="jc-form-label" htmlFor="rsvp-message">Birthday Message</label>
                                    <textarea
                                        id="rsvp-message"
                                        className="jc-form-textarea"
                                        placeholder="Share your wishes or a heartfelt message for Jenine Charisse…"
                                        value={rsvpData.message}
                                        onChange={(e) => setRsvpData({ ...rsvpData, message: e.target.value })}
                                    />
                                </div>

                                {rsvpError && <div className="jc-error-msg" role="alert">{rsvpError}</div>}

                                <button type="submit" className="jc-submit-btn" disabled={rsvpLoading}>
                                    {rsvpLoading ? 'Sending…' : 'Send My RSVP ✦'}
                                </button>

                                <p className="jc-rsvp-note">
                                    ✦ &nbsp; Kindly RSVP on or before <strong>{RSVP_DL}</strong>.<br />
                                    You may also reach out to the family directly for any inquiries.
                                </p>
                            </form>
                        )}
                    </BotanicalCard>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════
          13. FOOTER
         ══════════════════════════════════════════════════════════════ */}
            <footer id="footer" className="jc-footer">
                <div className="jc-reveal">
                    <img src={cursiveNameFooter} alt="Jenine Charisse" className="jc-footer-script" />
                    <p className="jc-footer-turns">Turns Eighteen &nbsp;·&nbsp; May 24, 2026</p>
                    <p className="jc-footer-message">
                        Thank you for being one of the cherished souls invited to witness this
                        enchanted celebration. Your love, your laughter, and your presence mean
                        everything to us. We cannot wait to celebrate with you.
                    </p>
                    <hr className="jc-footer-divider" aria-hidden="true" />
                    <p className="jc-footer-credit">✦ &nbsp; An Enchanted Garden Birthday</p>
                    <div className="jc-watermark">
                        <p>Created with ❤️ by</p>
                        <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer" aria-label="Visit Logica Technology">
                            <img src={logicaLogo} alt="Logica Technology" />
                        </a>
                    </div>
                </div>
            </footer>

        </div>
    );
}
